import 'bootstrap/dist/css/bootstrap.min.css';
import './SettingPopup.css';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button, ButtonGroup, Col, Container, FloatingLabel, Form, Image, InputGroup, ProgressBar, Row, Spinner, Tab, Table, Tabs, Toast, ToggleButton } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LoginInfo } from '../App.js';
import Birthday from '../domain/Birthday.ts';
import Email from '../domain/Email.js';
import HomePage from '../domain/HomePage.js';
import InstagramId from '../domain/InstagramId.js';
import Password from '../domain/Password.js';
import ProfileImage from '../domain/ProfileImage.js';
import SelfIntroduction from '../domain/SelfIntroduction.js';
import Sex from '../domain/Sex.js';
import TwitterId from '../domain/TwitterId.js';
import UserId from '../domain/UserId.js';
import UserInfo from '../domain/UserInfo.ts';
import AiWorksDisplayFlag from '../domain/R18DisplayFlag.js'
import UserName from '../domain/UserName.js';
import * as ImageUtil from '../service/ImageUtil.js';
import ApiFetch from './ApiFetch.js';
import Dialog from './Dialog.js';
import Footer from './Footer.js';
import Header from './Header.js';
import OnetimePassword from '../domain/OnetimePassword.js';
import CampaignMessage from './CampaignMessage.js';
import Category from './Category.js';
import R18DisplayFlag from '../domain/R18DisplayFlag.js';
import R18GDisplayFlag from '../domain/R18GDisplayFlag.js';
import DisplayId from '../domain/DisplayId.js';
import GitHubId from '../domain/GitHubId.js';
import HuggingFaceId from '../domain/HuggingFaceId.js';
import { useTranslation } from "react-i18next";
import { isLoggin } from '../service/LoginService.js';
import SexualExpressionDisplayFlag from '../domain/PG12DisplayFlag.js';
import Language from '../domain/Language.js';
import * as Icon from 'react-bootstrap-icons';
import PhoneNumber from '../domain/PhoneNumber.js';
import MuteButton from './MuteButton.js';
import { useCropper } from '../hooks/useCropper.js';
import ImageCropper from './common/ImageCropper.jsx';
import './common/ImageCropper.css';
import MisskeyId from '../domain/MisskeyId.js';
import { Line } from 'react-chartjs-2';
import BackgroundImage from '../domain/BackgroundImage.js';
import DynamicDialog from './DynamicDialog.js';
import UploadLeftBarDisplayFlag from '../domain/UploadLeftBarDisplayFlag.js';
import MuiButton from '@mui/material/Button'
import DiscordUserName from '../domain/DiscordUserName.js';
import R15DisplayFlag from '../domain/R15DisplayFlag.js';
import PG12DisplayFlag from '../domain/PG12DisplayFlag.js';
import KawaiiMode from '../domain/KawaiiMode.js';
import { Badge, Chip } from '@mui/material';
import UserNameKana from '../domain/UserNameKana.js';
import FeatureList from './common/FeatureList.js';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const SettingPopup = (props) => {
    function createGraphData(r, title) {
        const graphData = {
            labels:
                // 軸ラベル
                // 各ラベルを配列にすることで軸ラベルが改行されて表示される
                r.map(d => [d.ym])
            ,
            datasets: [
                // 表示するデータセット
                {
                    data: r.map(d => d.amount),
                    label: title
                },
            ],
        }
        return graphData
    }
    async function getUserInfo() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/profile/my")
            .then((r) => r.json().then((json) => {
                return json
            }))
    }
    async function getUserSetting() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/userSetting/my")
            .then((r) => r.json().then((json) => {
                return json
            }))
    }
    async function getMuteList(userId, page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/mute/muteList/" + userId + "/" + page)
            .then((r) => r.json().then((json) => {
                return json
            }))
    }
    async function update(userId, email, misskey, password, displayId, userName, userNameKana, homePage, twitterId, discordUserName, instagramId, githubId, huggingFaceId, sex, birthday, selfIntroduction, bgImg, img, dialog) {
        let userInfo = new UserInfo({
            userId: new UserId(userId), email: new Email(email), misskeyId: new MisskeyId(misskey), password: new Password(password), displayId: new DisplayId(displayId), userName: new UserName(userName),
            userNameKana: new UserNameKana(userNameKana), homePage: new HomePage(homePage), twitterId: new TwitterId(twitterId), discordUserName: new DiscordUserName(discordUserName), instagramId: new InstagramId(instagramId), gitHubId: new GitHubId(githubId),
            huggingFaceId: new HuggingFaceId(huggingFaceId), sex: new Sex(sex), birthday: new Birthday(birthday),
            selfIntroduction: new SelfIntroduction(selfIntroduction), backgroundImage: new BackgroundImage(bgImg.startsWith("data:") ? bgImg : ""), profileImage: new ProfileImage(img.startsWith("data:") ? img : "")
        })
        // 必須・文字数・パターン
        if (!userInfo.validate(dialog)) {
            return false
        }
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/profile/", userInfo.values).then((r) => {
            return r.json().then((json) => {
                if (!json.result) {
                    dialog("エラー", json.errors)
                }
                return json.result
            })
        })
    }
    async function updateDisplaySetting(pg12, r15, r18, r18g, bar, kawaii, lang, dialog) {
        let pg12DisplayFlag = new PG12DisplayFlag(pg12)
        let r15DisplayFlag = new R15DisplayFlag(r15)
        let r18DisplayFlag = new R18DisplayFlag(r18)
        let r18GDisplayFlag = new R18GDisplayFlag(r18g)
        let uploadLeftBarDisplayFlag = new UploadLeftBarDisplayFlag(bar)
        let kawaiiMode = new KawaiiMode(kawaii)
        let language = new Language(lang)
        // 必須・文字数・パターン
        if (!pg12DisplayFlag.validate(dialog)) {
            return false
        }
        // 必須・文字数・パターン
        if (!r15DisplayFlag.validate(dialog)) {
            return false
        }
        // 必須・文字数・パターン
        if (!r18DisplayFlag.validate(dialog)) {
            return false
        }
        // 必須・文字数・パターン
        if (!r18GDisplayFlag.validate(dialog)) {
            return false
        }
        // 必須・文字数・パターン
        if (!kawaiiMode.validate(dialog)) {
            return false
        }
        // 必須・文字数・パターン
        if (!uploadLeftBarDisplayFlag.validate(dialog)) {
            return false
        }
        // 言語
        if (!language.validate(dialog)) {
            return false
        }
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/userSetting/my",
            {
                pg12DisplayFlag: pg12DisplayFlag.props, r15DisplayFlag: r15DisplayFlag.props,
                r18DisplayFlag: r18DisplayFlag.props, r18GDisplayFlag: r18GDisplayFlag.props, kawaiiMode: kawaiiMode.props, uploadLeftBarDisplayFlag: uploadLeftBarDisplayFlag.props, language: language.props
            }
        ).then((r) => {
            return r.json().then((json) => {
                if (!json.result) {
                    dialog("エラー", json.errors)
                }
                return json.result
            })
        })
    }
    async function oneTimePasswordSend(email) {
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/onetime/password", { email: "dummy@example.com" })
            .then((r) => r.json().then((json) => {
                if (json.result) {
                    dialog("確認", "ワンタイムパスワードをメールアドレス宛に送信しました。届いた番号を入力してください。")
                    setOneTimePasswordSended(true)
                } else {
                    dialog("エラー", json.errors)
                    setOneTimePasswordSended(false)
                }
                return json.result
            }))
    }
    async function oneTimePasswordSendToPhoneNumber(phoneCountry, phoneNumber) {
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/onetime/sms", { phoneCountry: phoneCountry, phoneNumber: phoneNumber })
            .then((r) => r.json().then((json) => {
                if (json.result) {
                    dialog("確認", "ワンタイムパスワードを電話番号宛に送信しました。届いた番号を入力してください。")
                    setOneTimePasswordToPhoneNumberSended(true)
                } else {
                    dialog("エラー", json.errors)
                }
                return json.result
            }))
    }
    async function updatePassword(oldPassword, newPassword, newPasswordConfirm, onetimePassword, dialog) {
        let oldPasswordObj = new Password(oldPassword)
        let newPasswordObj = new Password(newPassword)
        let newPasswordConfirmObj = new Password(newPasswordConfirm)
        let onetimePasswordObj = new OnetimePassword(onetimePassword)
        // 必須・文字数・パターン
        if (!oldPasswordObj.validate(dialog) || !newPasswordObj.validate(dialog) || !onetimePasswordObj.validate(dialog) || !newPasswordConfirmObj.validate(dialog)) {
            return false
        }
        if (newPassword !== newPasswordConfirm) {
            dialog("エラー", "新パスワードと新パスワード再入力が異なります。")
            return false;
        }
        if (oldPassword === newPassword) {
            dialog("エラー", "旧パスワードと同じには設定できません。")
            return false;
        }
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/password/reset", { oldPassword: oldPasswordObj.props, newPassword: newPasswordObj.props, onetimePassword: onetimePasswordObj.props }).then((r) => {
            return r.json().then((json) => {
                if (json.result) {
                    dialog("確認", "変更完了しました。")
                    document.getElementById("old-password").value = ""
                    document.getElementById("new-password").value = ""
                    document.getElementById("new-password-confirm").value = ""
                    document.getElementById("onetime-password").value = ""
                    setOneTimePasswordSended(false)
                } else {
                    dialog("エラー", json.errors)
                }
                return json.result
            })
        })
    }
    async function smsAuth(phoneCountry, phoneNumber, onetimePassword, dialog) {
        let phoneNumberObj = new PhoneNumber({ phoneCountry, phoneNumber })
        let onetimePasswordObj = new OnetimePassword(onetimePassword)
        // 必須・文字数・パターン
        if (!phoneNumberObj.validate(dialog) || !onetimePasswordObj.validate(dialog)) {
            return false
        }
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/sms/auth", { phoneNumber: phoneNumberObj.props, onetimePassword: onetimePasswordObj.props }).then((r) => {
            return r.json().then((json) => {
                if (json.result) {
                    dialog("確認", "認証しました。")
                    setSMSCertified(true)
                    document.getElementById("phone-number").value = ""
                    document.getElementById("onetime-password-sms").value = ""
                    setOneTimePasswordToPhoneNumberSended(false)
                } else {
                    dialog("エラー", json.errors)
                }
                return json.result
            })
        })
    }
    async function deleteAccount() {
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/login/deleteAccount", {}).then((r) => {
            return r.json().then((json) => {
                return json
            })
        })
    }
    async function getUserDetailInfo(userIdOrDisplayId) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/profile/" + userIdOrDisplayId)
            .then((r) => r.json().then((json) => {
                return json
            }))
    }
    async function certifiedCreatorReview() {
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/monetization/certifiedCreatorReview")
            .then((r) => r.json().then((json) => {
                return json
            }))
    }
    async function getRevenue() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/monetization/revenue")
            .then((r) => r.json().then((json) => {
                return json
            }))
    }
    async function getRevenueByMonth() {
        return new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/monetization/revenueByMonth").then((r) => {
            return r.json()
        })
    }
    async function getGenerateSecretKey() {
        return new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/userApi/generateSecretKey").then((r) => {
            return r.json()
        })
    }
    async function payoutsSetup() {
        return new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/monetization/payoutsSetup").then((r) => {
            return r.json()
        })
    }
    async function getLoginLink() {
        return new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/monetization/loginLink").then((r) => {
            return r.json()
        })
    }
    async function getTerms() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/messages/terms").then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getFavoriteMessage() {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/favorite/message").then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function updateFavoriteMessage(mes1, mes2, mes3, mes4, mes5, mes6, mes7, mes8, mes9, mes10) {
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/favorite/message", {
            mes1: mes1, mes2: mes2, mes3: mes3, mes4: mes4, mes5: mes5, mes6: mes6, mes7: mes7, mes8: mes8, mes9: mes9, mes10: mes10
        }).then((r) => r.json().then((json) => {
            return json
        }))
    }
    // 招待
    async function getReferrerResult(userIdOrDisplayId) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/profile/referrerResult/" + userIdOrDisplayId).then((r) => r.json().then((json) => {
            return json
        }))
    }
    async function getLinkOAuth(type) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/login/outsideLinkOAuth/" + type).then((r) => r.json().then((json) => {
            return json
        }))
    }

    const { t, i18n } = useTranslation()
    // ログイン情報
    const { loginInfo, setLoginInfo } = useContext(LoginInfo)
    const [userDetailInfo, setUserDetailInfo] = useState([])
    const [follower, setFollower] = useState(0)
    const [postedImagesWithoutR18, setPostedImagesWithoutR18] = useState(0)
    const [avgPV, setAvgPV] = useState(0)
    const [avgFavorite, setAvgFavorite] = useState(0)
    const [generatedImagePostCount, setGeneratedImagePostCount] = useState(0)
    const [favoriteMessage, setFavoriteMessage] = useState([])

    // 収益化関連
    const [revenue, setRevenue] = useState(0)
    const [revenueByMonthList, setRevenueByMonthList] = useState()
    const [referrerResult, setReferrerResult] = useState([])

    // ナビゲート
    const navigate = useNavigate();

    const [oneTimePasswordSended, setOneTimePasswordSended] = useState(false)
    const [oneTimePasswordToPhoneNumberSended, setOneTimePasswordToPhoneNumberSended] = useState(false);
    const [phoneCountry, setPhoneCountry] = useState("jp")
    const [smsCertified, setSMSCertified] = useState(false)
    const [backgroundImage, setBackgroundImage] = useState("")
    const [profileImage, setProfileImage] = useState("")
    const [srcImage, setSrcImage] = useState("")

    const [updating, setUpdating] = useState(false)
    const [payoutsSetupProccess, setPayoutsSetupProccess] = useState(false)

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title, message) {
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    const [activeKey, setActiveKey] = useState("account")

    // フラグ：AI生成作品を表示する
    const [pg12Value, setPG12Value] = useState('2') // 性的表現(軽微)
    const [r15Value, setR15Value] = useState('2')
    const [r18Value, setR18Value] = useState('2')
    const [r18GValue, setR18GValue] = useState('2')
    const [uploadLeftBarValue, setUploadLeftBarValue] = useState('2')
    const [kawaiiValue, setKawaiiValue] = useState('2')
    const [userInfo, setUserInfo] = useState([])
    const [userSetting, setUserSetting] = useState([])
    const [sex, setSex] = useState(1)
    const [birthday, setBirthday] = useState("")
    const [language, setLanguage] = useState(1)
    const [lock15, setLock15] = useState(false)
    const [lock18, setLock18] = useState(false)
    const [muteList, setMuteList] = useState([])

    const [loading, setLoading] = useState(false)

    // 初期処理
    useEffect(() => {
        // タイトル設定
        document.querySelector("title").textContent = t("category.setting") + " - アワートAI"
        getUserInfo().then(r => {
            setUserInfo(r)
            setSex(r.sex)
            setBirthday(r.birthday)
            setLock15(r.age < 15)
            setLock18(r.age < 18)
            if (r.certified_creator === 1) {
                getRevenue().then(r => {
                    if (r.result) {
                        setRevenue(r.data)
                    }
                })
                getRevenueByMonth().then(r => {
                    if (r.result) {
                        setRevenueByMonthList(<Line data={createGraphData(r.data, "推移")} />)
                    }
                })
            }
        })
        getUserSetting().then(r => {
            setUserSetting(r)
            setPG12Value(String(r.data.pg12_display_flag))
            setR15Value(String(r.data.r15_display_flag))
            setR18Value(String(r.data.r18_display_flag))
            setR18GValue(String(r.data.r18g_display_flag))
            setUploadLeftBarValue(String(r.data.upload_left_bar_display_flag))
            setKawaiiValue(String(r.data.kawaii_mode))
            setLanguage(String(r.data.language))
        })
        if(props.activeKey) {
            setActiveKey(props.activeKey)
        }
    }, [])

    useEffect(() => {
        // 画像が設定されている場合
        if (backgroundImage.startsWith("data:image/jpeg")) {
            console.log("読み込み完了")
        }
        if (profileImage.startsWith("data:image/jpeg")) {
            console.log("読み込み完了")
        }
    }, [backgroundImage, profileImage])

    // ログイン情報が取得出来たらプロフィール画像に設定
    useEffect(() => {
        if (loginInfo.result === false) {
            navigate("/")
        }
        setBackgroundImage("//" + ApiFetch.IMG_HOST + "/profile/" + loginInfo.userId + "_bg.webp?" + loginInfo.hash)
        setProfileImage("//" + ApiFetch.IMG_HOST + "/profile/" + loginInfo.userId + "_m.jpg?" + loginInfo.hash)
    }, [loginInfo])

    const radios = [
        { name: t("common.yes"), value: "1" },
        { name: t("common.no"), value: "2" },
    ]
    document.onkeydown = (e) => {
        if (e.key === "Escape") {
            props.switch(false)
        }
    }

    // 背景画像用のクロッパー（アスペクト比 2:1）
    const backgroundCropper = useCropper(2);
    // プロフィール画像用のクロッパー（アスペクト比 1:1）
    const profileCropper = useCropper(1);
    const [showPayoutsTerms, setShowPayoutsTerms] = useState(false)
    const [payoutsTerms, setPayoutsTerms] = useState()
    useEffect(() => {
        if (showPayoutsTerms) {
            getTerms().then(r => {
                if (r.result) {
                    setPayoutsTerms(r.text)
                }
            })
        }
    }, [showPayoutsTerms])
    return (
        <div>
            {/* Backdrop overlay */}
            <div style={{ 
                position: "fixed", 
                top: 0, 
                left: 0, 
                width: "100%", 
                height: "100%", 
                backgroundColor: "rgba(0, 0, 0, 0.5)", 
                zIndex: 1050,
                backdropFilter: "blur(4px)"
            }}></div>
            
            {/* Main popup container */}
            <div style={{ 
                position: "fixed", 
                top: 0, 
                left: 0, 
                width: "100%", 
                height: "100%", 
                zIndex: 1051, 
                display: loginInfo.result && loginInfo.status !== 0 ? "none" : "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px"
            }}>
                <div id="setting-popup" style={{ 
                    position: "relative",
                    width: "100%", 
                    maxWidth: "1200px",
                    height: "95vh",
                    maxHeight: "900px",
                    backgroundColor: "#FFFFFF", 
                    borderRadius: "16px",
                    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column"
                }}>
                    {/* Header with close button */}
                    <div style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                        backgroundColor: "#fff",
                        borderBottom: "1px solid #e9ecef",
                        padding: "16px 24px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <h2 style={{ margin: 0, fontSize: "24px", fontWeight: "600", color: "#212529" }}>
                            {t("category.setting")}
                        </h2>
                        <Button 
                            variant='outline-secondary' 
                            size="sm"
                            onClick={() => props.switch(false)}
                            style={{ borderRadius: "8px" }}
                        >
                            <Icon.X size={18} />
                        </Button>
                    </div>
                    
                    {/* Content area with scroll */}
                    <div style={{ 
                        flex: 1, 
                        overflow: "auto",
                        padding: "0"
                    }}>
                        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
                        <Container fluid className='h-100'>
                            <Tabs 
                                activeKey={activeKey}
                                id="settings-tabs" 
                                className="nav-pills nav-justified"
                                style={{
                                    backgroundColor: "#f8f9fa",
                                    borderBottom: "none",
                                    padding: "8px 16px 0"
                                }}
                                onSelect={(key) => {
                                    setActiveKey(key)
                                    if (key === "mute") {
                                        setMuteList([])
                                        getMuteList(loginInfo.userId, 1).then(r => {
                                            if (r.result) {
                                                setMuteList(r.data)
                                            } else {
                                                dialog(t("common.error"), r.errors)
                                            }
                                        })
                                    }
                                    if (key === "monetization") {
                                        getUserDetailInfo(userInfo.user_id).then(r => {
                                            if (r.result) {
                                                setUserDetailInfo(r)
                                                setFollower(r.follower)
                                                setPostedImagesWithoutR18(r.image_without_r18)
                                                setAvgPV(r.pv_3month)
                                                setAvgFavorite(r.favorite_3month)
                                                setGeneratedImagePostCount(r.generated_image_post_count)
                                            }
                                        })
                                        getReferrerResult(userInfo.user_id).then(r => {
                                            if (r.result) {
                                                setReferrerResult(r.data)
                                            }
                                        })
                                    }
                                    if (key === "other") {
                                        getFavoriteMessage().then(r => {
                                            if (r.result) {
                                                document.getElementById("fav-mes1").value = r.data.m1 !== undefined ? r.data.m1 : ""; r.data.m2 !== undefined ? r.data.m2 : ""
                                                document.getElementById("fav-mes3").value = r.data.m3 !== undefined ? r.data.m3 : ""; document.getElementById("fav-mes4").value = r.data.m4 !== undefined ? r.data.m4 : ""
                                                document.getElementById("fav-mes5").value = r.data.m5 !== undefined ? r.data.m5 : ""; document.getElementById("fav-mes6").value = r.data.m6 !== undefined ? r.data.m6 : ""
                                                document.getElementById("fav-mes7").value = r.data.m7 !== undefined ? r.data.m7 : ""; document.getElementById("fav-mes8").value = r.data.m8 !== undefined ? r.data.m8 : ""
                                                document.getElementById("fav-mes9").value = r.data.m9 !== undefined ? r.data.m9 : ""; document.getElementById("fav-mes10").value = r.data.m10 !== undefined ? r.data.m10 : ""
                                                setFavoriteMessage(r.data)
                                            }
                                        })
                                    }
                                }}>
                            <Tab 
                                eventKey="account" 
                                title={
                                    <div className="d-flex align-items-center justify-content-center">
                                        <Icon.PersonFill className="me-2" />
                                        <span className='d-none d-lg-inline'>{t("setting.account.title")}</span>
                                    </div>
                                }
                                className='w-100'
                            >
                                <div style={{ padding: "24px" }}>
                                    <div className="mb-4">
                                        <h3 className="mb-3" style={{ 
                                            fontSize: "28px", 
                                            fontWeight: "600", 
                                            color: "#212529",
                                            borderBottom: "2px solid #007bff",
                                            paddingBottom: "8px"
                                        }}>
                                            {t("setting.account.title")}
                                        </h3>
                                    </div>

                                    {/* Profile Images Section - Twitter/X Style */}
                                    <div className="mb-5" style={{ 
                                        backgroundColor: "#ffffff", 
                                        borderRadius: "16px",
                                        border: "1px solid #e1e8ed",
                                        overflow: "hidden",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)"
                                    }}>
                                        {/* Header */}
                                        <div className="p-3 border-bottom" style={{ backgroundColor: "#f7f9fa" }}>
                                            <h5 className="mb-0" style={{ fontWeight: "700", color: "#14171a", fontSize: "20px" }}>
                                                <Icon.PersonBadge className="me-2" />
                                                プロフィール画像
                                            </h5>
                                        </div>

                                        {/* Background Image with Profile Image Overlay */}
                                        <div className="position-relative" style={{ height: "250px" }}>
                                            {/* Background Image */}
                                            <div 
                                                className="position-relative w-100 h-100"
                                                style={{ 
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease-in-out"
                                                }}
                                                onMouseEnter={(e) => {
                                                    const overlay = e.currentTarget.querySelector('.bg-overlay');
                                                    if (overlay) overlay.style.opacity = "1";
                                                }}
                                                onMouseLeave={(e) => {
                                                    const overlay = e.currentTarget.querySelector('.bg-overlay');
                                                    if (overlay) overlay.style.opacity = "0";
                                                }}
                                                onClick={() => document.getElementById("bg-file").click()}
                                            >
                                                <Image 
                                                    src={backgroundImage} 
                                                    style={{ 
                                                        width: "100%", 
                                                        height: "100%", 
                                                        objectFit: "contain",
                                                        filter: "brightness(0.95)"
                                                    }} 
                                                />
                                                {/* Background Image Overlay */}
                                                <div 
                                                    className="bg-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                                    style={{
                                                        backgroundColor: "rgba(0,0,0,0.4)",
                                                        opacity: "0",
                                                        transition: "opacity 0.2s ease-in-out"
                                                    }}
                                                >
                                                    <div className="text-center text-white">
                                                        <Icon.CameraFill size={32} className="mb-2" />
                                                        <div style={{ fontSize: "14px", fontWeight: "600" }}>
                                                            背景画像を変更
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Profile Image positioned at bottom left */}
                                            <div 
                                                className="position-absolute"
                                                style={{ 
                                                    bottom: "-40px", 
                                                    left: "20px",
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease-in-out"
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = "scale(1.05)";
                                                    const overlay = e.currentTarget.querySelector('.profile-overlay');
                                                    if (overlay) overlay.style.opacity = "1";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = "scale(1)";
                                                    const overlay = e.currentTarget.querySelector('.profile-overlay');
                                                    if (overlay) overlay.style.opacity = "0";
                                                }}
                                                onClick={() => document.getElementById("file").click()}
                                            >
                                                <div className="position-relative">
                                                    <Image 
                                                        src={profileImage} 
                                                        style={{ 
                                                            width: "120px", 
                                                            height: "120px", 
                                                            borderRadius: "50%",
                                                            border: "4px solid #ffffff",
                                                            objectFit: "cover",
                                                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                                                        }} 
                                                    />
                                                    {/* Profile Image Overlay */}
                                                    <div 
                                                        className="profile-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                                        style={{
                                                            backgroundColor: "rgba(0,0,0,0.5)",
                                                            borderRadius: "50%",
                                                            opacity: "0",
                                                            transition: "opacity 0.2s ease-in-out"
                                                        }}
                                                    >
                                                        <Icon.CameraFill size={24} color="white" />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Edit buttons in top right corner */}
                                            <div 
                                                className="position-absolute"
                                                style={{ top: "15px", right: "15px" }}
                                            >
                                                <div className="d-flex gap-2">
                                                    <MuiButton 
                                                        variant="contained"
                                                        size="small"
                                                        onClick={() => document.getElementById("bg-file").click()}
                                                        style={{ 
                                                            borderRadius: "20px",
                                                            backgroundColor: "rgba(0,0,0,0.75)",
                                                            color: "white",
                                                            border: "1px solid rgba(255,255,255,0.2)",
                                                            backdropFilter: "blur(10px)",
                                                            fontSize: "12px",
                                                            padding: "6px 16px",
                                                            textTransform: "none",
                                                            fontWeight: "600"
                                                        }}
                                                        sx={{
                                                            '&:hover': {
                                                                backgroundColor: "rgba(0,0,0,0.85)"
                                                            }
                                                        }}
                                                    >
                                                        <Icon.ImageFill className="me-1" size={14} />
                                                        背景
                                                    </MuiButton>
                                                    <MuiButton 
                                                        variant="contained"
                                                        size="small"
                                                        onClick={() => document.getElementById("file").click()}
                                                        style={{ 
                                                            borderRadius: "20px",
                                                            backgroundColor: "rgba(0,0,0,0.75)",
                                                            color: "white",
                                                            border: "1px solid rgba(255,255,255,0.2)",
                                                            backdropFilter: "blur(10px)",
                                                            fontSize: "12px",
                                                            padding: "6px 16px",
                                                            textTransform: "none",
                                                            fontWeight: "600"
                                                        }}
                                                        sx={{
                                                            '&:hover': {
                                                                backgroundColor: "rgba(0,0,0,0.85)"
                                                            }
                                                        }}
                                                    >
                                                        <Icon.PersonCircle className="me-1" size={14} />
                                                        アイコン
                                                    </MuiButton>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Spacer for profile image overlap */}
                                        <div style={{ paddingTop: "60px" }}></div>

                                        {/* Hidden file inputs */}
                                        <Form.Control 
                                            type="file" 
                                            accept=".jpg,.jpeg,.gif,.png,.webp" 
                                            className='d-none' 
                                            id="bg-file" 
                                            onChange={(e) => {
                                                ImageUtil.loadImageBig(e.currentTarget.files, (imageUrl) => {
                                                    backgroundCropper.openCropper(imageUrl, 2) // 2:1 アスペクト比に戻す
                                                }, false)
                                                document.getElementById("bg-file").value = ""
                                            }} 
                                        />
                                        <Form.Control 
                                            type="file" 
                                            accept=".jpg,.jpeg,.gif,.png,.webp" 
                                            className='d-none' 
                                            id="file" 
                                            onChange={(e) => {
                                                ImageUtil.loadImageBig(e.currentTarget.files, (imageUrl) => {
                                                    profileCropper.openCropper(imageUrl, 1) // アスペクト比 1:1
                                                }, false)
                                                document.getElementById("file").value = ""
                                            }} 
                                        />
                                    </div>
                                    {/* ImageCropper components */}
                                    <ImageCropper 
                                        isOpen={backgroundCropper.showCropper}
                                        image={backgroundCropper.originalImage}
                                        crop={backgroundCropper.crop}
                                        zoom={backgroundCropper.zoom}
                                        aspectRatio={backgroundCropper.aspectRatio}
                                        isProcessing={backgroundCropper.isProcessing}
                                        onCropChange={backgroundCropper.setCrop}
                                        onZoomChange={backgroundCropper.setZoom}
                                        onCropComplete={backgroundCropper.onCropComplete}
                                        onClose={backgroundCropper.closeCropper}
                                        onSave={() => {
                                            if (backgroundCropper.croppedImage) {
                                                setBackgroundImage(backgroundCropper.croppedImage);
                                                backgroundCropper.closeCropper();
                                            }
                                        }}
                                        title="背景画像を編集"
                                    />
                                    <ImageCropper 
                                        isOpen={profileCropper.showCropper}
                                        image={profileCropper.originalImage}
                                        crop={profileCropper.crop}
                                        zoom={profileCropper.zoom}
                                        aspectRatio={profileCropper.aspectRatio}
                                        isProcessing={profileCropper.isProcessing}
                                        onCropChange={profileCropper.setCrop}
                                        onZoomChange={profileCropper.setZoom}
                                        onCropComplete={profileCropper.onCropComplete}
                                        onClose={profileCropper.closeCropper}
                                        onSave={() => {
                                            if (profileCropper.croppedImage) {
                                                setProfileImage(profileCropper.croppedImage);
                                                profileCropper.closeCropper();
                                            }
                                        }}
                                        title="プロフィール画像を編集"
                                    />

                                    {/* Account Information Form */}
                                    <div className="mb-4">
                                        <h5 className="mb-3" style={{ fontWeight: "600", color: "#495057" }}>
                                            <Icon.InfoCircle className="me-2" />
                                            基本情報
                                        </h5>
                                        
                                        <div className="mb-3 p-3" style={{ 
                                            backgroundColor: "#e7f3ff", 
                                            borderRadius: "8px",
                                            border: "1px solid #b3d9ff"
                                        }}>
                                            <Icon.Link45deg className="me-2" />
                                            <strong>招待リンク：</strong>
                                            <span className="user-select-all">
                                                https://ourt-ai.work/invite/{userInfo.display_id === "" ? userInfo.user_id : userInfo.display_id}
                                            </span>
                                        </div>

                                        <div className="mb-3 p-3" style={{ 
                                            backgroundColor: "#e7f3ff", 
                                            borderRadius: "8px",
                                            border: "1px solid #b3d9ff"
                                        }}>
                                            <strong>招待リンクは作品やモデルページの最後に「?af={userInfo.display_id === "" ? userInfo.user_id : userInfo.display_id}」を追加することでも利用できます。</strong>
                                            <br />
                                            <span className="user-select-all">
                                                例：https://ourt-ai.work/image/xxxxxxxxxxxxxxxx?af={userInfo.display_id === "" ? userInfo.user_id : userInfo.display_id}
                                            </span>
                                        </div>

                                        <Row>
                                            <Col md={6}>
                                                <FloatingLabel controlId="user-id" label={t("setting.account.userId")} className="mb-3">
                                                    <Form.Control type="text" defaultValue={userInfo.user_id} disabled style={{ borderRadius: "8px" }} />
                                                </FloatingLabel>
                                            </Col>
                                            <Col md={6}>
                                                <FloatingLabel controlId="display-id" label={t("setting.account.displayId")} className="mb-3">
                                                    <Form.Control type="text" defaultValue={userInfo.display_id} style={{ borderRadius: "8px" }} />
                                                </FloatingLabel>
                                            </Col>
                                        </Row>
                                        
                                        <div className="mb-3 text-muted small">
                                            {t("setting.account.displayIdMessage")}<br />
                                            {t("setting.account.characterString")}
                                        </div>

                                        <Row>
                                            <Col md={6}>
                                                <FloatingLabel controlId="name" label={t("setting.account.userName")} className="mb-3">
                                                    <Form.Control type="text" defaultValue={userInfo.user_name} style={{ borderRadius: "8px" }} />
                                                </FloatingLabel>
                                            </Col>
                                            <Col md={6}>
                                                <FloatingLabel controlId="name-kana" label={"よみがな"} className="mb-3">
                                                    <Form.Control type="text" defaultValue={userInfo.user_name_kana} style={{ borderRadius: "8px" }} />
                                                </FloatingLabel>
                                            </Col>
                                        </Row>

                                        <FloatingLabel controlId="email" label={t("setting.account.email")} className="mb-3">
                                            <Form.Control type="email" defaultValue={userInfo.email} disabled style={{ borderRadius: "8px" }} />
                                        </FloatingLabel>
                                    </div>

                                    {/* Social Media Links */}
                                    <div className="mb-4">
                                        <h5 className="mb-3" style={{ fontWeight: "600", color: "#495057" }}>
                                            <Icon.Share className="me-2" />
                                            ソーシャルメディア
                                        </h5>

                                        <div className="mb-3">
                                            <label className="form-label d-flex align-items-center">
                                                <Image src="/img/misskey.png" width="20px" className="me-2" />
                                                Misskey ID (ourt AI)
                                            </label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text style={{ borderRadius: "8px 0 0 8px" }}>sns.ourt-ai.work/@</InputGroup.Text>
                                                <Form.Control
                                                    id="misskey"
                                                    placeholder="Misskey ID(ourt AI)"
                                                    defaultValue={userInfo.misskey_id}
                                                    style={{ borderRadius: "0 8px 8px 0" }}
                                                />
                                            </InputGroup>
                                        </div>

                                        <Row>
                                            <Col md={6}>
                                                <FloatingLabel controlId="hp" label={t("setting.account.homepage")} className="mb-3">
                                                    <Form.Control type="text" defaultValue={userInfo.homepage} style={{ borderRadius: "8px" }} />
                                                </FloatingLabel>
                                            </Col>
                                            <Col md={6}>
                                                <FloatingLabel controlId="twitter" label={t("setting.account.twitterId")} className="mb-3">
                                                    <Form.Control type="text" defaultValue={userInfo.twitter_id} style={{ borderRadius: "8px" }} />
                                                </FloatingLabel>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6}>
                                                <FloatingLabel controlId="discord" label={<><Icon.Discord /> Discord User Name</>} className="mb-3">
                                                    <Form.Control type="text" defaultValue={userInfo.discord_user_name} style={{ borderRadius: "8px" }} />
                                                </FloatingLabel>
                                            </Col>
                                            <Col md={6}>
                                                <FloatingLabel controlId="instagram" label={t("setting.account.instagramId")} className="mb-3">
                                                    <Form.Control type="text" defaultValue={userInfo.instagram_id} style={{ borderRadius: "8px" }} />
                                                </FloatingLabel>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6}>
                                                <FloatingLabel controlId="github" label={t("setting.account.githubId")} className="mb-3">
                                                    <Form.Control type="text" defaultValue={userInfo.github_id} style={{ borderRadius: "8px" }} />
                                                </FloatingLabel>
                                            </Col>
                                            <Col md={6}>
                                                <FloatingLabel controlId="hugging-face" label={t("setting.account.huggingFaceId")} className="mb-3">
                                                    <Form.Control type="text" defaultValue={userInfo.huggingface_id} style={{ borderRadius: "8px" }} />
                                                </FloatingLabel>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Personal Information */}
                                    <div className="mb-4">
                                        <h5 className="mb-3" style={{ fontWeight: "600", color: "#495057" }}>
                                            <Icon.PersonBadge className="me-2" />
                                            個人情報
                                        </h5>

                                        <Row>
                                            <Col md={6}>
                                                <label className="form-label">
                                                    {t("setting.account.sex")} 
                                                    <span style={{ fontSize: "12px", color: "#6c757d", marginLeft: "8px" }}>
                                                        ({t("setting.account.private")})
                                                    </span>
                                                </label>
                                                <Form.Select 
                                                    id="sex" 
                                                    className="mb-3" 
                                                    value={sex} 
                                                    onChange={(e) => setSex(e.target.value)} 
                                                    disabled={userInfo.sex !== 0}
                                                    style={{ borderRadius: "8px" }}
                                                >
                                                    <option value="0">未設定</option>
                                                    <option value="1">{t("setting.account.male")}</option>
                                                    <option value="2">{t("setting.account.female")}</option>
                                                </Form.Select>
                                            </Col>
                                            <Col md={6}>
                                                <FloatingLabel controlId="birthday" label={t("setting.account.birthday")} className="mb-3">
                                                    <Form.Control 
                                                        type="date" 
                                                        defaultValue={userInfo.birthday === "9999-12-31" ? "" : userInfo.birthday} 
                                                        disabled={userInfo.birthday !== "9999-12-31"} 
                                                        onChange={(e) => setBirthday(e.target.value)}
                                                        style={{ borderRadius: "8px" }}
                                                    />
                                                </FloatingLabel>
                                            </Col>
                                        </Row>

                                        <FloatingLabel controlId="self‐introduction" label={t("setting.account.selfIntroduction")} className="mb-4">
                                            <Form.Control
                                                as="textarea"
                                                style={{ height: '120px', borderRadius: "8px" }}
                                                defaultValue={userInfo.self_introduction}
                                                onInput={(e) => {
                                                    let lineHeight = 20
                                                    let n = e.nativeEvent.target.value.match(/\n/g)
                                                    if (n === null) {
                                                        n = 1
                                                    } else {
                                                        n = n.length + 1
                                                    }
                                                    e.currentTarget.style.height = Math.max(120, lineHeight * n + 30) + "px"
                                                }}
                                            />
                                        </FloatingLabel>
                                    </div>

                                    {/* Update Button */}
                                    <div className="text-center">
                                        <MuiButton 
                                            variant='contained' 
                                            size="large"
                                            disabled={updating}
                                            onClick={() => {
                                                setUpdating(true)
                                                update(
                                                    "userId",
                                                    "test@example.com",
                                                    document.getElementById("misskey").value,
                                                    "p@ssw0rd",
                                                    document.getElementById("display-id").value,
                                                    document.getElementById("name").value,
                                                    document.getElementById("name-kana").value,
                                                    document.getElementById("hp").value,
                                                    document.getElementById("twitter").value,
                                                    document.getElementById("discord").value,
                                                    document.getElementById("instagram").value,
                                                    document.getElementById("github").value,
                                                    document.getElementById("hugging-face").value,
                                                    sex,
                                                    birthday,
                                                    document.getElementById("self‐introduction").value,
                                                    backgroundImage,
                                                    profileImage,
                                                    dialog
                                                ).then((r) => {
                                                    if (r) {
                                                        isLoggin().then(json => {
                                                            setLoginInfo(json)
                                                        })
                                                        dialog("確認", "変更が完了しました。")
                                                        getUserInfo().then(r => {
                                                            setUserInfo(r)
                                                            setSex(r.sex)
                                                            setBirthday(r.birthday)
                                                            setLock15(r.age < 15)
                                                            setLock18(r.age < 18)
                                                        })
                                                    }
                                                    setUpdating(false)
                                                })
                                            }}
                                            style={{ 
                                                borderRadius: "8px",
                                                padding: "12px 32px",
                                                fontSize: "16px"
                                            }}
                                        >
                                            {updating ? <Spinner animation="border" size="sm" className="me-2" /> : <Icon.CheckCircle className="me-2" />}
                                            {t("setting.account.update")}
                                        </MuiButton>
                                    </div>
                                </div>
                            </Tab>
                            <Tab 
                                eventKey="outside" 
                                title={
                                    <div className="d-flex align-items-center justify-content-center">
                                        <Icon.Share className="me-2" />
                                        <span className='d-none d-lg-inline'>外部ID連携</span>
                                    </div>
                                }
                                className='w-100'
                            >
                                <div style={{ padding: "24px" }}>
                                    <div className="mb-4">
                                        <h3 className="mb-3" style={{ 
                                            fontSize: "28px", 
                                            fontWeight: "600", 
                                            color: "#212529",
                                            borderBottom: "2px solid #007bff",
                                            paddingBottom: "8px"
                                        }}>
                                            外部アカウント連携
                                        </h3>
                                        <p className="text-muted">
                                            外部サービスと連携することで、より多くの特典やサービスを利用できます。
                                        </p>
                                    </div>

                                    <div className="row g-4">
                                        {/* World ID Section */}
                                        <div className="col-12 col-md-6">
                                            <div className="card h-100" style={{ borderRadius: "12px", border: "1px solid #dee2e6" }}>
                                                <div className="card-body p-4">
                                                    <div className="d-flex align-items-center mb-3">
                                                        <img width={32} height={32} src='/img/logos/worldcoin-org-wld-logo.svg' className="me-3" />
                                                        <h5 className="card-title mb-0" style={{ fontWeight: "600" }}>World ID</h5>
                                                        {userInfo.world_id_auth === 1 ? 
                                                            <Icon.CheckCircle style={{ color: "green", marginLeft: "auto" }} size={24} /> : 
                                                            <Icon.DashCircle style={{ color: "grey", marginLeft: "auto" }} size={24} />
                                                        }
                                                    </div>
                                                    
                                                    {userInfo.world_id_auth === 0 && (
                                                        <div className="alert alert-info" style={{ borderRadius: "8px" }}>
                                                            <Icon.Gift className="me-2" />
                                                            World ID連携で50万生成ポイント付与
                                                        </div>
                                                    )}
                                                    
                                                    <div className="d-flex justify-content-center">
                                                        <Chip 
                                                            disabled={loading || userInfo.world_id_auth === 1} 
                                                            onClick={() => {
                                                                setLoading(true)
                                                                getLinkOAuth("worldId").then(r => {
                                                                    if (r.result) {
                                                                        window.location.href = r.data.url
                                                                    } else {
                                                                        dialog("", r.errors)
                                                                        setLoading(false)
                                                                    }
                                                                })
                                                            }} 
                                                            style={{ 
                                                                fontSize: "16px",
                                                                padding: "12px 24px"
                                                            }} 
                                                            label={
                                                                userInfo.world_id_auth === 1 ? "連携済み" : "連携する"
                                                            }
                                                            variant={userInfo.world_id_auth === 1 ? "filled" : "outlined"}
                                                            color={userInfo.world_id_auth === 1 ? "success" : "primary"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Misskey Section */}
                                        <div className="col-12 col-md-6">
                                            <div className="card h-100" style={{ borderRadius: "12px", border: "1px solid #dee2e6" }}>
                                                <div className="card-body p-4">
                                                    <div className="d-flex align-items-center mb-3">
                                                        <img width={32} height={32} src='/img/misskey.png' className="me-3" />
                                                        <h5 className="card-title mb-0" style={{ fontWeight: "600" }}>Misskey</h5>
                                                        {userInfo.misskey_id_auth === 1 ? 
                                                            <Icon.CheckCircle style={{ color: "green", marginLeft: "auto" }} size={24} /> : 
                                                            <Icon.DashCircle style={{ color: "grey", marginLeft: "auto" }} size={24} />
                                                        }
                                                    </div>
                                                    
                                                    <p className="text-muted small mb-3">
                                                        Misskeyアカウントと連携してソーシャル機能を拡張
                                                    </p>
                                                    
                                                    <div className="d-flex justify-content-center">
                                                        <Chip 
                                                            disabled={loading || userInfo.misskey_id_auth === 1} 
                                                            onClick={() => {
                                                                setLoading(true)
                                                                getLinkOAuth("misskey").then(r => {
                                                                    if (r.result) {
                                                                        window.location.href = r.data.url
                                                                    } else {
                                                                        dialog("", r.errors)
                                                                        setLoading(false)
                                                                    }
                                                                })
                                                            }} 
                                                            style={{ 
                                                                fontSize: "16px",
                                                                padding: "12px 24px"
                                                            }} 
                                                            label={
                                                                userInfo.misskey_id_auth === 1 ? "連携済み" : "連携する"
                                                            }
                                                            variant={userInfo.misskey_id_auth === 1 ? "filled" : "outlined"}
                                                            color={userInfo.misskey_id_auth === 1 ? "success" : "primary"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab 
                                eventKey="display" 
                                title={
                                    <div className="d-flex align-items-center justify-content-center">
                                        <Icon.DisplayFill className="me-2" />
                                        <span className='d-none d-lg-inline'>{t("setting.displaySettings.title")}</span>
                                    </div>
                                }
                                style={{ width: "100%" }}
                            >
                                <div style={{ padding: "24px" }}>
                                    <div className="mb-4">
                                        <h3 className="mb-3" style={{ 
                                            fontSize: "28px", 
                                            fontWeight: "600", 
                                            color: "#212529",
                                            borderBottom: "2px solid #007bff",
                                            paddingBottom: "8px"
                                        }}>
                                            {t("setting.displaySettings.title")}
                                        </h3>
                                        <p className="text-muted">
                                            コンテンツの表示設定を管理します。年齢制限のあるコンテンツの表示を制御できます。
                                        </p>
                                    </div>

                                    {/* Content Filter Settings */}
                                    <div className="mb-5">
                                        <h5 className="mb-4" style={{ fontWeight: "600", color: "#495057" }}>
                                            <Icon.ShieldCheck className="me-2" />
                                            コンテンツフィルター
                                        </h5>

                                        <div className="row g-4">
                                            {/* PG12 Setting */}
                                            <div className="col-12">
                                                <div className="card" style={{ borderRadius: "12px", border: "1px solid #dee2e6" }}>
                                                    <div className="card-body p-4">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <h6 className="mb-1" style={{ fontWeight: "600" }}>
                                                                    PG-12
                                                                </h6>
                                                                <small className="text-muted">軽微な性的表現を含むコンテンツの表示設定</small>
                                                            </div>
                                                            <ButtonGroup>
                                                                {radios.map((radio, idx) => (
                                                                    <ToggleButton
                                                                        key={idx}
                                                                        id={`radio-pg12-${idx}`}
                                                                        type="radio"
                                                                        variant={pg12Value === radio.value ? 'primary' : 'outline-primary'}
                                                                        name="radio-pg12"
                                                                        value={radio.value}
                                                                        checked={pg12Value === radio.value}
                                                                        onChange={(e) => setPG12Value(e.currentTarget.value)}
                                                                        disabled={lock15}
                                                                        style={{ borderRadius: idx === 0 ? "8px 0 0 8px" : "0 8px 8px 0" }}
                                                                    >
                                                                        {radio.name}
                                                                    </ToggleButton>
                                                                ))}
                                                            </ButtonGroup>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* R15 Setting */}
                                            <div className="col-12">
                                                <div className="card" style={{ borderRadius: "12px", border: "1px solid #dee2e6" }}>
                                                    <div className="card-body p-4">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <h6 className="mb-1" style={{ fontWeight: "600" }}>
                                                                    {t("setting.displaySettings.r15")}
                                                                </h6>
                                                                <small className="text-muted">15歳未満向けでないコンテンツの表示設定</small>
                                                            </div>
                                                            <ButtonGroup>
                                                                {radios.map((radio, idx) => (
                                                                    <ToggleButton
                                                                        key={idx}
                                                                        id={`radio-r15-${idx}`}
                                                                        type="radio"
                                                                        variant={r15Value === radio.value ? 'primary' : 'outline-primary'}
                                                                        name="radio-r15"
                                                                        value={radio.value}
                                                                        checked={r15Value === radio.value}
                                                                        onChange={(e) => setR15Value(e.currentTarget.value)}
                                                                        disabled={lock15}
                                                                        style={{ borderRadius: idx === 0 ? "8px 0 0 8px" : "0 8px 8px 0" }}
                                                                    >
                                                                        {radio.name}
                                                                    </ToggleButton>
                                                                ))}
                                                            </ButtonGroup>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* R18 Setting */}
                                            <div className="col-12">
                                                <div className="card" style={{ borderRadius: "12px", border: "1px solid #dee2e6" }}>
                                                    <div className="card-body p-4">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <h6 className="mb-1" style={{ fontWeight: "600" }}>
                                                                    {t("setting.displaySettings.r18")}
                                                                </h6>
                                                                <small className="text-muted">18歳未満向けでないコンテンツの表示設定</small>
                                                            </div>
                                                            <ButtonGroup>
                                                                {radios.map((radio, idx) => (
                                                                    <ToggleButton
                                                                        key={idx}
                                                                        id={`radio-r18-${idx}`}
                                                                        type="radio"
                                                                        variant={r18Value === radio.value ? 'primary' : 'outline-primary'}
                                                                        name="radio-r18"
                                                                        value={radio.value}
                                                                        checked={r18Value === radio.value}
                                                                        onChange={(e) => setR18Value(e.currentTarget.value)}
                                                                        disabled={lock18}
                                                                        style={{ borderRadius: idx === 0 ? "8px 0 0 8px" : "0 8px 8px 0" }}
                                                                    >
                                                                        {radio.name}
                                                                    </ToggleButton>
                                                                ))}
                                                            </ButtonGroup>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* R18G Setting */}
                                            <div className="col-12">
                                                <div className="card" style={{ borderRadius: "12px", border: "1px solid #dee2e6" }}>
                                                    <div className="card-body p-4">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <h6 className="mb-1" style={{ fontWeight: "600" }}>
                                                                    {t("setting.displaySettings.r18g")}
                                                                </h6>
                                                                <small className="text-muted">グロテスクな表現を含むコンテンツの表示設定</small>
                                                            </div>
                                                            <ButtonGroup>
                                                                {radios.map((radio, idx) => (
                                                                    <ToggleButton
                                                                        key={idx}
                                                                        id={`radio-r18g-${idx}`}
                                                                        type="radio"
                                                                        variant={r18GValue === radio.value ? 'primary' : 'outline-primary'}
                                                                        name="radio-r18g"
                                                                        value={radio.value}
                                                                        checked={r18GValue === radio.value}
                                                                        onChange={(e) => setR18GValue(e.currentTarget.value)}
                                                                        disabled={lock18}
                                                                        style={{ borderRadius: idx === 0 ? "8px 0 0 8px" : "0 8px 8px 0" }}
                                                                    >
                                                                        {radio.name}
                                                                    </ToggleButton>
                                                                ))}
                                                            </ButtonGroup>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Interface Settings */}
                                    <div className="mb-5">
                                        <h5 className="mb-4" style={{ fontWeight: "600", color: "#495057" }}>
                                            <Icon.Gear className="me-2" />
                                            インターフェース設定
                                        </h5>

                                        <div className="row g-4">
                                            {/* Upload Left Bar Setting */}
                                            <div className="col-12">
                                                <div className="card" style={{ borderRadius: "12px", border: "1px solid #dee2e6" }}>
                                                    <div className="card-body p-4">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <h6 className="mb-1" style={{ fontWeight: "600" }}>
                                                                    {t("upload.leftBar")}
                                                                </h6>
                                                                <small className="text-muted">アップロード画面の左サイドバーの表示設定</small>
                                                            </div>
                                                            <ButtonGroup>
                                                                {radios.map((radio, idx) => (
                                                                    <ToggleButton
                                                                        key={idx}
                                                                        id={`radio-upload-left-bar-${idx}`}
                                                                        type="radio"
                                                                        variant={uploadLeftBarValue === radio.value ? 'primary' : 'outline-primary'}
                                                                        name="radio-upload-left-bar"
                                                                        value={radio.value}
                                                                        checked={uploadLeftBarValue === radio.value}
                                                                        onChange={(e) => setUploadLeftBarValue(e.currentTarget.value)}
                                                                        style={{ borderRadius: idx === 0 ? "8px 0 0 8px" : "0 8px 8px 0" }}
                                                                    >
                                                                        {radio.name}
                                                                    </ToggleButton>
                                                                ))}
                                                            </ButtonGroup>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Kawaii Mode Setting */}
                                            <div className="col-12 d-none">
                                                <div className="card" style={{ borderRadius: "12px", border: "1px solid #dee2e6", opacity: 0.6 }}>
                                                    <div className="card-body p-4">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <h6 className="mb-1" style={{ fontWeight: "600" }}>
                                                                    Kawaii Mode
                                                                    <Badge bg="secondary" className="ms-2">準備中</Badge>
                                                                </h6>
                                                                <small className="text-muted">可愛いテーマの表示設定（準備中）</small>
                                                            </div>
                                                            <ButtonGroup>
                                                                {radios.map((radio, idx) => (
                                                                    <ToggleButton
                                                                        disabled
                                                                        key={idx}
                                                                        id={`radio-kawaii-mode-${idx}`}
                                                                        type="radio"
                                                                        variant={kawaiiValue === radio.value ? 'primary' : 'outline-primary'}
                                                                        name="radio-kawaii-mode"
                                                                        value={radio.value}
                                                                        checked={kawaiiValue === radio.value}
                                                                        onChange={(e) => setKawaiiValue(e.currentTarget.value)}
                                                                        style={{ borderRadius: idx === 0 ? "8px 0 0 8px" : "0 8px 8px 0" }}
                                                                    >
                                                                        {radio.name}
                                                                    </ToggleButton>
                                                                ))}
                                                            </ButtonGroup>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Language Setting */}
                                            <div className="col-12">
                                                <div className="card" style={{ borderRadius: "12px", border: "1px solid #dee2e6" }}>
                                                    <div className="card-body p-4">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>
                                                                <h6 className="mb-1" style={{ fontWeight: "600" }}>
                                                                    <Icon.Globe className="me-2" />
                                                                    Language
                                                                </h6>
                                                                <small className="text-muted">表示言語の設定</small>
                                                            </div>
                                                            <div style={{ minWidth: "200px" }}>
                                                                <Form.Select 
                                                                    id="language" 
                                                                    value={language} 
                                                                    onChange={(e) => {
                                                                        let language = e.target.value
                                                                        i18n.changeLanguage(language)
                                                                        setLanguage(language)
                                                                    }}
                                                                    style={{ borderRadius: "8px" }}
                                                                >
                                                                    <option value="ja">日本語</option>
                                                                    <option value="en">English</option>
                                                                    <option value="zhtw">中文(繁體)</option>
                                                                    <option value="zhCN">中文(简体)</option>
                                                                    <option value="ko">한국어</option>
                                                                </Form.Select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Apply Button */}
                                    <div className="text-center">
                                        <MuiButton 
                                            variant='contained' 
                                            size="large"
                                            onClick={() => updateDisplaySetting(
                                                pg12Value,
                                                r15Value,
                                                r18Value,
                                                r18GValue,
                                                uploadLeftBarValue,
                                                kawaiiValue,
                                                language,
                                                dialog
                                            ).then((r) => {
                                                if (r) {
                                                    window.location.reload()
                                                }
                                            })}
                                            style={{ 
                                                borderRadius: "8px",
                                                padding: "12px 32px",
                                                fontSize: "16px"
                                            }}
                                        >
                                            <Icon.CheckCircle className="me-2" />
                                            {t("setting.displaySettings.apply")}
                                        </MuiButton>
                                    </div>

                                    {/* Certified Creator Section */}
                                    {userInfo.certified_creator === 1 && (
                                        <>
                                            <hr className="my-5" />
                                            <div className="mb-4">
                                                <h5 className="mb-3" style={{ fontWeight: "600", color: "#495057" }}>
                                                    <Icon.Award className="me-2" />
                                                    公認クリエイター
                                                </h5>
                                                <div className="text-center">
                                                    <MuiButton 
                                                        variant='outlined' 
                                                        onClick={() => navigate("/creatorManage")}
                                                        style={{ borderRadius: "8px" }}
                                                    >
                                                        公認欄の表示設定
                                                    </MuiButton>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </Tab>
                            <Tab eventKey="monetization" title={<><Icon.Coin /> <span className='d-none d-lg-inline'>{t("setting.monetization.title")}</span></>}>
                                <h2>収益化</h2>
                                <div style={{ borderBottom: "1px solid #555555" }} className='mb-3'>
                                    <b>1.メンバーシップ機能</b>
                                </div>
                                メンバーシップ機能を有効化することで、プランを作成し、投稿を月額料金で提供したり、単品販売ができるようになります。<br />
                                また、投げ銭(応援コメント機能)も受け取ることができるようになります。<br />
                                本人確認、売上の出金先銀行口座登録、SMS認証を済ませることで利用できます。<br />
                                メンバーシップ機能については、公認クリエイター支援制度の要件を満たすことなく利用できます。<br />
                                <div className='text-center'>
                                    <MuiButton onClick={() => navigate('/manage/payouts')} variant='contained' className='m-3'>メンバーシップの設定へ</MuiButton>
                                </div>
                                <div style={{ borderBottom: "1px solid #555555" }} className='mb-3'><b>2.公認クリエイター支援制度</b>
                                    {userInfo.certified_creator_review_status === 2 ? <span>&nbsp;<Icon.ShieldFillCheck style={{ color: "green" }} /> 登録済み</span> : ""}
                                </div>
                                {userInfo.certified_creator === 0 && userInfo.certified_creator_review_status === 0 ? <>
                                    <span>アワートAI クリエイター支援制度に参加することで、様々な特典を得ましょう。</span>
                                    <div>
                                        公認クリエイター特典<br />
                                        <FeatureList />
                                        参加要件<br />
                                        基本事項を満たし、申請要件がすべて100%以上であること。<br /><br />

                                        1. 申請要件 <Icon.QuestionCircle style={{ color: "#555555", cursor: "pointer" }} onClick={() => dialog(t("common.info"), <>
                                            過去3か月間の画像作品の投稿に対する評価が対象になります。<br />
                                            現在のところ、成人向けコンテンツは対象外になりますが、<br />
                                            公認クリエイター制度参加後も、引き続き成人向けコンテンツの投稿はできます。
                                        </>)} /><br />
                                        <ProgressBar id="step1-progress" animated now={Math.floor((follower / 50) * 100)} label={`${Math.floor((follower / 50) * 100)}%`} />
                                        フォロワー {follower} / 50<br /><br />

                                        <ProgressBar id="step3-progress" animated now={Math.floor((postedImagesWithoutR18 / 200) * 100)} label={`${Math.floor((postedImagesWithoutR18 / 200) * 100)}%`} />
                                        公開投稿の総投稿数 {postedImagesWithoutR18} / 200<br /><br />

                                        <ProgressBar id="step3-progress" animated now={Math.floor((avgPV / 20) * 100)} label={`${Math.floor((avgPV / 20) * 100)}%`} />
                                        公開投稿に対する平均閲覧数 {avgPV} / 20<br />
                                        <span style={{ fontSize: "14px", color: "#555555" }}>過去3か月間</span><br /><br />

                                        <ProgressBar id="step2-progress" animated now={Math.floor((avgFavorite / 10) * 100)} label={`${Math.floor((avgFavorite / 10) * 100)}%`} />
                                        公開投稿に対する認証済みユーザーからの平均いいね数 {avgFavorite} / 10<br />
                                        <span style={{ fontSize: "14px", color: "#555555" }}>過去3か月間</span><br /><br />

                                        <ProgressBar id="step2-progress" animated now={Math.floor((generatedImagePostCount / 100) * 100)} label={`${Math.floor((generatedImagePostCount / 100) * 100)}%`} />
                                        AI生成機能を利用して生成したプロンプトを公開している画像の投稿数 {generatedImagePostCount} / 100<br />
                                        <span style={{ fontSize: "14px", color: "#555555" }}>合計</span><br /><br />

                                        2. 基本事項<br />
                                        ・SMS認証済み<br />
                                        ・プロフィールの充実<br />
                                        ・利用規約、ガイドラインの遵守<br /><br />
                                        <Link to={"/terms"} target='_blank'>利用規約、公認クリエイター細則を確認</Link><br /><br />
                                        <Button variant='outline-primary'
                                            disabled={loginInfo.role.find(d => d.role_div === "admin") && !(Math.floor((follower / 50) * 100) >= 100 && Math.floor((avgFavorite / 15) * 100) >= 100 && Math.floor((avgPV / 30) * 100) >= 100 && Math.floor((postedImagesWithoutR18 / 200) * 100) >= 100 && Math.floor((generatedImagePostCount / 100) * 100) >= 100)}
                                            onClick={() => {
                                                certifiedCreatorReview().then(r => {
                                                    if (r.result) {
                                                        dialog("", "申請しました。")
                                                        getUserInfo().then(r => {
                                                            setUserInfo(r)
                                                        })
                                                    } else {
                                                        dialog("", r.errors)
                                                    }
                                                })
                                            }}
                                        >審査を申請する</Button><br /><br />
                                    </div>
                                </> : (
                                    // 審査中
                                    userInfo.certified_creator_review_status === 1 ? (
                                        <>
                                            <span style={{ fontSize: "14px", color: "#555555" }}>審査申請済:結果待ち</span><br />
                                        </>
                                    ) : (
                                        // 審査通過
                                        userInfo.certified_creator_review_status === 2 ? (
                                            <>
                                                <div style={{ display: userInfo.plan === "certification" || userInfo.plan === "unlimited" || userInfo.plan === "plus" ? "block" : "none" }}>
                                                    {/*<div className='mb-3 p-1' style={{backgroundColor:"pink",color:"#333333",borderRadius:"5px"}}><Icon.ExclamationCircle style={{color:"red"}} /> これは実験中のデータです。実際に発生した金額ではなく、出金できません。<br />テストが終わればリセットされます。</div>*/}
                                                    <div className='text-center mb-3'>
                                                        <span style={{ fontWeight: "bold", fontSize: "36px" }}>{revenue.amount}</span> <span style={{ fontWeight: "" }}>JPY</span><br />
                                                        最終出金日：{revenue.last_payout_datetime}
                                                        {revenueByMonthList}
                                                    </div>
                                                    最終発生月
                                                    <Table striped bordered hover style={{ width: "100%" }}>
                                                        <thead>
                                                            <tr><th>年月</th><th>金額</th></tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr><td>{revenue.last_ym}</td><td>{revenue.last_amount} JPY</td></tr>
                                                        </tbody>
                                                    </Table>
                                                    {/*<Button className='m-1' variant='outline-primary' disabled>銀行口座に出金</Button>
                                <Button className='m-1' variant='outline-primary' disabled>Amazonギフト券に交換</Button><br />*/}
                                                </div>
                                                {userInfo.payouts === 2 ?
                                                    (<>
                                                        <Button className='m-1' variant='outline-secondary' onClick={() => {
                                                            setPayoutsSetupProccess(true)
                                                            getLoginLink().then(r => {
                                                                if (r.result) {
                                                                    window.location.href = r.data.url
                                                                } else {
                                                                    dialog(t("common.info", r.errors))
                                                                }
                                                                //setPayoutsSetupProccess(false)
                                                            })
                                                        }} disabled={payoutsSetupProccess}>{payoutsSetupProccess ? <Spinner animation="border" size="sm" /> : ""} 入金アカウントを管理</Button><br />
                                                    </>) : (<>
                                                        {userInfo.plan === "certification" || userInfo.plan === "unlimited" || userInfo.plan === "plus" ?
                                                            (<>
                                                                <Button className='m-1' variant='outline-secondary' onClick={() => {
                                                                    setShowPayoutsTerms(true)
                                                                }} disabled={payoutsSetupProccess}>
                                                                    {payoutsSetupProccess ? <Spinner animation="border" size="sm" /> : ""} {userInfo.charges_enabled === 1 && userInfo.payouts_enabled === 0 ? "確認中" : "口座設定"}
                                                                </Button>
                                                                {userInfo.charges_enabled === 1 && userInfo.payouts_enabled === 0 ? <Button onClick={() => window.location.href = "/callback/payoutsSetup"}>状況を確認</Button> : ""}
                                                            </>) : (
                                                                <>
                                                                    <Icon.CheckCircleFill style={{ color: "green" }} /> 公認クリエイターへ登録済<br />
                                                                    {userInfo.sms_auth === 1 ? <Icon.CheckCircleFill style={{ color: "green" }} /> : <Icon.Circle />} SMS認証済<br />
                                                                    <Icon.Circle /> スタンダードプランまたはプレミアムプランに加入している
                                                                </>
                                                            )}
                                                    </>)}
                                                {userInfo.payouts === 2 ? <>出金期限：{revenue.payout_limit_datetime}</> : ""}
                                                <br /><br />
                                                <Link to={"/terms"} target='_blank'>利用規約、公認クリエイター細則を確認</Link><br /><br />
                                                公認クリエイター特典<br />
                                                ①トップページで作品が紹介されます。<br />
                                                ②作品の投稿の評価によって活動支援金を得ることができます。<br />
                                                ・支援金制度の参加には別途、課金プラン加入(スタンダードまたはプレミアム)が必要です。<br />
                                                ③投稿枚数無制限<br /><br />
                                            </>
                                        ) : (
                                            userInfo.certified_creator_review_status === 3 ? (
                                                <>
                                                    <span style={{ fontSize: "14px", color: "#555555" }}>審査申請済:不認定</span><br />
                                                </>) : ""
                                        )
                                    )
                                )}
                                {showPayoutsTerms ? (
                                    <DynamicDialog switch={setShowPayoutsTerms} width={window.innerWidth * 0.9} height={window.innerHeight} content={<Container>
                                        <Button variant='outline-secondary' className='m-3' onClick={() => { setShowPayoutsTerms(false) }}>閉じる</Button>
                                        <Container className='mb-3'>口座設定するために、改めて利用規約への同意が必要です。</Container>
                                        <Container className='mb-3'>口座設定にはStripeを使用しています。<br />
                                            Stripeでのアカウント登録に必要なメールアドレス、電話番号、名前、生年月日を含む身分証の提出と銀行口座登録することに同意するものとします。</Container>
                                        <Container className='w-100' dangerouslySetInnerHTML={{ __html: payoutsTerms }} />
                                        <Container className='text-center'>
                                            <Button className='m-3' onClick={() => {
                                                setPayoutsSetupProccess(true)
                                                payoutsSetup().then(r => {
                                                    if (r.result) {
                                                        if (!r.data.isPayoutsEnabled) {
                                                            window.location.href = r.data.accountLink
                                                        } else {
                                                            dialog(t("common.info"), "口座設定は完了しています。")
                                                            setPayoutsSetupProccess(false)
                                                            getUserInfo().then(r => {
                                                                setUserInfo(r)
                                                            })
                                                        }
                                                    } else {
                                                        dialog(t("common.info"), r.errors)
                                                        setPayoutsSetupProccess(false)
                                                    }
                                                    setShowPayoutsTerms(false)
                                                })
                                            }} disabled={payoutsSetupProccess}>{payoutsSetupProccess ? <Spinner animation="border" size="sm" /> : ""} 同意する</Button>
                                            <Button className='m-3' onClick={() => {
                                                setShowPayoutsTerms(false)
                                            }} disabled={payoutsSetupProccess}>同意しない</Button>
                                        </Container>
                                    </Container>} />
                                ) : ""}
                                <div className='d-block'>
                                    <hr />
                                    <h5>招待制度(準備中)</h5>
                                    招待リンクから招待されたユーザーが有料プランに入った場合、各プランに応じて報酬が支払われます。<br /><br />
                                    <Container className='text-center' style={{ backgroundColor: "#FFFFFF" }}>残高: <span style={{ fontSize: "28px" }}>99,xxx</span> JPY<br /></Container>
                                    <MuiButton variant='outlined' className='m-1' onClick={() => alert("集計期間中の数値です。")}>
                                        <span style={{ fontWeight: "bold" }}>招待したユーザー：</span><span style={{ fontWeight: "bold", fontSize: "18px" }}>{referrerResult.count}</span>
                                    </MuiButton>
                                    <MuiButton variant='outlined' className='m-1' onClick={() => alert("集計期間中の数値です。")}>
                                        <span style={{ fontWeight: "bold" }}>内有料プラン加入者：</span><span style={{ fontWeight: "bold", fontSize: "18px" }}>{referrerResult.planCount}</span>
                                    </MuiButton>
                                    <br />1万円以上で自動振り込みが行われます。振込手数料500円が差し引かれます。
                                </div>
                            </Tab>
                            <Tab eventKey="password" title={<><Icon.KeyFill /> <span className='d-none d-lg-inline'>{t("setting.passwordReset.title")}</span></>}>
                                <Container className='mt-3 mb-3' style={{ width: "100%" }}>
                                    <h3>{t("setting.passwordReset.title")}</h3>
                                    <FloatingLabel controlId="old-password" label={t("setting.passwordReset.password")} className="mb-3">
                                        <Form.Control type="password" placeholder="" />
                                    </FloatingLabel>
                                    <FloatingLabel controlId="new-password" label={t("setting.passwordReset.newPassword")} className="mb-3">
                                        <Form.Control type="password" placeholder="" autoComplete="new-password" />
                                    </FloatingLabel>
                                    <FloatingLabel controlId="new-password-confirm" label={t("setting.passwordReset.newPasswordConfirm")} className="mb-3">
                                        <Form.Control type="password" placeholder="" />
                                    </FloatingLabel>
                                    <p>{t("setting.passwordReset.characterString")}</p>
                                    <MuiButton variant='contained' onClick={() => {
                                        if (new Password(document.getElementById("old-password").value).validate(dialog, true)
                                            && new Password(document.getElementById("new-password").value).validate(dialog, true)
                                            && new Password(document.getElementById("new-password-confirm").value).validate(dialog, true)) {

                                            oneTimePasswordSend(document.getElementById("email").value)
                                        }
                                    }} className="mb-1">{t("setting.passwordReset.sendOnetimePassword")}</MuiButton>
                                    <div className="mb-3">{t("setting.passwordReset.sendMessage")}</div>
                                    <FloatingLabel controlId="onetime-password" label="ワンタイムパスワード" style={{ display: oneTimePasswordSended ? "block" : "none" }}>
                                        <Form.Control type="number" cows="10" />
                                    </FloatingLabel>
                                    <MuiButton variant='contained' onClick={() => {
                                        updatePassword(
                                            document.getElementById("old-password").value,
                                            document.getElementById("new-password").value,
                                            document.getElementById("new-password-confirm").value,
                                            document.getElementById("onetime-password").value,
                                            dialog
                                        )
                                    }} className="mt-3">{t("setting.passwordReset.update")}</MuiButton>
                                </Container>
                            </Tab>
                            <Tab eventKey="security" title={<><Icon.DoorClosedFill /> <span className='d-none d-lg-inline'>{t("setting.security.title")}</span></>}>
                                <Container className='mt-3 mb-3' style={{ width: "100%" }}>
                                    {false /*loginInfo.plan === "" || loginInfo.plan === "basic"*/ ? (
                                        <>
                                            <MuiButton onClick={() => navigate("/legal")} severity='success' variant='outlined' className='m-1' startIcon={<AutoAwesomeIcon />}>スタンダードプラン以上に登録して、SMS認証、本人確認する。</MuiButton>
                                        </>
                                    ) : (
                                        <>
                                            <h3>{t("setting.security.smsAuth")}</h3>
                                            {userInfo.sms_auth === 1 || smsCertified ? (<p>{t("common.certified")} <Icon.CheckCircleFill style={{ color: "#1D9BF0" }} /></p>) : ""}
                                            <Container className='p-0' style={{ display: userInfo.sms_auth === 1 || smsCertified ? "none" : "block" }}>
                                                <Form.Select id="phone-contry" className="mb-3" value={phoneCountry} onChange={(e) => setPhoneCountry(e.target.value)} disabled={oneTimePasswordToPhoneNumberSended}>
                                                    <option value="jp">+81 Japan</option>
                                                    <option value="tw">+886 Taiwan</option>
                                                    <option value="hk">+852 Hong Kong</option>
                                                    <option value="fr">+33 France</option>
                                                    <option value="th">+66 Thailand</option>
                                                    <option value="de">+49 Germany </option>
                                                </Form.Select>
                                                <FloatingLabel controlId="phone-number" label={t("setting.security.phoneNumber")} className="mb-3">
                                                    <Form.Control type="text" placeholder="" disabled={oneTimePasswordToPhoneNumberSended} />
                                                </FloatingLabel>
                                                <Button onClick={() => {
                                                    if (new PhoneNumber(document.getElementById("phone-number").value).validate(phoneCountry, dialog, true)) {
                                                        oneTimePasswordSendToPhoneNumber(phoneCountry, document.getElementById("phone-number").value)
                                                    }
                                                }} className="mb-1">{t("setting.security.sendOnetimePassword")}</Button>
                                                <div className="mb-3">{t("setting.security.sendMessage")}</div>
                                                <FloatingLabel controlId="onetime-password-sms" label="ワンタイムパスワード" style={{ display: oneTimePasswordToPhoneNumberSended ? "block" : "none" }}>
                                                    <Form.Control type="number" cows="10" disabled={false /*loginInfo.plan === "" || loginInfo.plan === "basic"*/} />
                                                </FloatingLabel>
                                                <Button onClick={() => {
                                                    smsAuth(
                                                        phoneCountry,
                                                        document.getElementById("phone-number").value,
                                                        document.getElementById("onetime-password-sms").value,
                                                        dialog
                                                    )
                                                }} className="mt-3" disabled={!oneTimePasswordToPhoneNumberSended}>{t("setting.security.auth")}</Button><br /><br />
                                            </Container>
                                            <h3>本人確認</h3>
                                            <Link to={"/manage/id"}><MuiButton variant='outlined' style={{ marginLeft: "10px" }}>
                                                本人確認
                                                {loginInfo.id_auth === 1 ? <>&nbsp;<Icon.CheckCircle style={{ color: "green" }} /></>
                                                    : <>&nbsp;<Icon.ExclamationCircle style={{ color: "red" }} /></>}
                                            </MuiButton></Link>
                                        </>
                                    )}
                                </Container>
                            </Tab>
                            <Tab eventKey={"mute"} title={<><Icon.PersonX /> <span className='d-none d-lg-inline'>{t("common.muted")}</span></>}>
                                <Row>
                                    {muteList.map((d, i) => {
                                        return (
                                            <Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="p-1" key={i}>
                                                <Container className="p-1" style={{ border: "1px solid #CCCCCC", borderRadius: "5px" }}>
                                                    <div className='d-flex justify-content-start'>
                                                        <div>
                                                            <Link to={"/user/" + d.mute_target_user_id}><Image data-type="mute" data-observe="0" data-no={i} className="lazy" loading="lazy" src={ApiFetch.API_PROTOCOL + "//" + ApiFetch.IMG_HOST + "/profile/" + d.mute_target_user_id + ".jpg"} style={{ width: "50px", height: "auto", borderRadius: "50%" }} /></Link>
                                                        </div>
                                                        <div className='p-3'>
                                                            <Link to={"/user/" + d.mute_target_user_id} style={{ textDecoration: "none", color: "#000000" }}>{d.user_name}</Link>
                                                            <br />
                                                            <div style={{ cursor: "pointer", border: "1px solid #000000", display: "inline-block" }}>
                                                                <MuteButton userId={d.mute_target_user_id} mute={d.mute} userName={d.user_name} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p>{d.self_introduction}</p>
                                                </Container>
                                            </Col>
                                        )
                                    })}
                                </Row>
                            </Tab>
                            <Tab eventKey="other" title={<><Icon.PersonBadge /> <span className='d-none d-lg-inline'>{t("setting.other.title")}</span></>}>
                                <Container className='mt-3 mb-3' style={{ width: "100%" }}>
                                    <h3>いいねへのお礼を設定</h3>
                                    作品にいいねされたときに表示するメッセージを設定します。<br />
                                    {[...Array(10)].map((d, i) => {
                                        return <FloatingLabel controlId={"fav-mes" + (i + 1)} label={"メッセージ" + (i + 1)} className="mb-1">
                                            <Form.Control type="text" placeholder="" defaultValue={""} />
                                        </FloatingLabel>
                                    })}
                                    <MuiButton variant='contained' onClick={() => {
                                        let mes1 = document.getElementById("fav-mes1")
                                        let mes2 = document.getElementById("fav-mes2")
                                        let mes3 = document.getElementById("fav-mes3")
                                        let mes4 = document.getElementById("fav-mes4")
                                        let mes5 = document.getElementById("fav-mes5")
                                        let mes6 = document.getElementById("fav-mes6")
                                        let mes7 = document.getElementById("fav-mes7")
                                        let mes8 = document.getElementById("fav-mes8")
                                        let mes9 = document.getElementById("fav-mes9")
                                        let mes10 = document.getElementById("fav-mes10")
                                        updateFavoriteMessage(
                                            mes1 !== undefined ? mes1.value : "", mes2 !== undefined ? mes2.value : "",
                                            mes3 !== undefined ? mes3.value : "", mes4 !== undefined ? mes4.value : "",
                                            mes5 !== undefined ? mes5.value : "", mes6 !== undefined ? mes6.value : "",
                                            mes7 !== undefined ? mes7.value : "", mes8 !== undefined ? mes8.value : "",
                                            mes9 !== undefined ? mes9.value : "", mes10 !== undefined ? mes10.value : ""
                                        ).then(r => {
                                            if (r.result) {
                                                dialog("", "更新しました。")
                                            } else {
                                                dialog("", r.errors)
                                            }
                                        })
                                    }}>設定</MuiButton>
                                </Container>
                                <hr />
                                <Container className='mt-3' style={{ width: "100%",marginBottom: "50px" }}>
                                    <div className='d-none'>
                                        <h3>API</h3>
                                        APIを利用することで画面を介さず様々な操作を行うことができます。<br />
                                        <Button
                                            onClick={() => dialog(t("common.confirm"), <>
                                                <p >このキーは絶対に誰にも教えないでください。また、表示のたびに再発行されます。</p>
                                                <Button
                                                    onClick={() => {
                                                        getGenerateSecretKey().then(r => {
                                                            if (r.result) {
                                                                dialog("", <div style={{ wordBreak: "break-all" }}>
                                                                    シークレットキー:<br />
                                                                    {r.data.hash}
                                                                </div>)
                                                            }
                                                        })
                                                    }}
                                                >発行</Button>
                                            </>)}
                                        >シークレットアクセスキーを表示</Button>
                                    </div>

                                    <div>
                                        <h3>アカウント削除</h3>
                                        <MuiButton variant='outlined' color='warning'
                                            onClick={() => dialog(t("common.info"), <>アカウントを削除しますか？<br />
                                                削除するには、「アカウント削除」と入力してください。<br />
                                                <FloatingLabel controlId="account-delete-input" label={"入力"} className="mb-3">
                                                    <Form.Control type="text" placeholder="" />
                                                </FloatingLabel>
                                                <MuiButton variant='contained' color='warning'
                                                    onClick={() => {
                                                        let input = document.querySelector("#account-delete-input").value
                                                        if (input !== "アカウント削除") {
                                                            alert("入力が誤っています。")
                                                            return
                                                        }
                                                        deleteAccount().then(r => {
                                                            if (r.result) {
                                                                dialog(t("common.info"), <>アカウントは削除されました。<br /><MuiButton variant='outlined' onClick={() => window.location.reload()}>OK</MuiButton></>)
                                                            }
                                                        })
                                                    }}
                                                >削除</MuiButton>
                                            </>)}
                                        >アカウントの削除</MuiButton>
                                    </div>
                                </Container>
                            </Tab>
                        </Tabs>
                        </Container>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SettingPopup;
